module.exports = __webpack_public_path__ + "media/svg/turno-manha-ded4061a.svg";